import { buildDeepLinkUrl } from "../../services/theme-deeplink";

interface ThemeIntegrationBarProps {
  loading: boolean;
  enabled: boolean | null;
}

export const ThemeIntegrationBar = ({
  loading,
  enabled,
}: ThemeIntegrationBarProps) => {
  const handleOpenTheme = () => {
    const url = buildDeepLinkUrl();
    window.open(url, "_blank");
  };

  const badgeLabel = loading
    ? "..."
    : enabled === null
      ? "--"
      : enabled
        ? "ON"
        : "OFF";
  const badgeStatus =
    loading || enabled === null ? undefined : enabled ? "success" : undefined;

  return (
    <s-section>
      <s-stack direction="block" gap="base">
        <s-stack
          direction="inline"
          gap="base"
          alignItems="center"
          justifyContent="space-between"
        >
          <s-stack direction="inline" gap="base" alignItems="center">
            <s-icon type="app-extension" />
            <s-text>Integración de Aplicación en Tema</s-text>
            <s-badge tone={badgeStatus}>{badgeLabel}</s-badge>
          </s-stack>
          <s-button variant="secondary" onClick={handleOpenTheme}>
            Abrir Tema
          </s-button>
        </s-stack>

        {!loading && enabled === false && (
          <s-banner tone="warning">
            <s-text>
              El widget no estará activo en tu tienda mientras la integración
              esté deshabilitada.
            </s-text>
          </s-banner>
        )}
      </s-stack>
    </s-section>
  );
};
